import React from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Newsletter } from './components/Newsletter';
import { Apply } from './components/Apply';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white text-navy-900" data-id="element-0">
      <Hero data-id="element-1" />
      <About data-id="element-2" />
      <Newsletter data-id="element-3" />
      <Apply data-id="element-4" />
      <Footer data-id="element-5" />
    </div>;
}